import api from '@/api'
import CampaignRequest from '@/model/campaign/CampaignRequest'
import CampaignSearchRequest from '@/model/campaign/CampaignSearchRequest'
import AffiliateRequest from '@/model/affiliate/AffiliateRequest';

export default {
  namespaced: true,
  state: {
    statusIds: []
  },
  getters: {
    statusIds: state => state.statusIds,
    statusById: state => id => state.statusIds.find(status => status.id === id)
  },
  mutations: {
    updateData(state, data) {
    }
  },
  actions: {
    refreshData({ commit }) {
      return api.base()
        .get('/campaign/data')
        .then(
          response => {
            commit('updateData', response.data.data);
          }
        );
    },
    getAllCampaigns(actions, {filter,pagination,sort}) {
      return api.base()
        .post('/campaign/get/all',
          CampaignSearchRequest( { ...(filter || {}), pagination, sort, })
        )
        .then(response => ({
            data: response.data.data,
            pagination: { page: response.data.metadata.page, total: response.data.metadata.total},
            sort: response.data.metadata.sort
          })
        )
    },
    getCampaignById({ commit }, id) {
      return api.base()
        .get('/campaign/id/' + id)
        .then(
          response => {
            return response.data.data
          }
        )
    },
    togglePlayingAction({ commit }, { id, action }) {
      return api.base()
        .post('/campaign/toggle-playing/' + id,action )
        .then(
          response => {
            return response.data.data
          }
        )
    }
,
    createCampaign({ commit }, { campaign }) {
      return api.base()
        .post('/campaign/add', CampaignRequest(campaign))
        .then(
          response => {
            return response.data.data;
          }
        );
    },
    updateCampaign({ commit }, { campaign, id }) {
      return api.base()
        .post('/campaign/update/'+id, CampaignRequest(campaign))
        .then(
          response => {
            return response.data.data
          }
        )
    }
  },
}
